import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Gallery } from "./pages/Gallery";
import { Testimonials } from "./pages/Testimonials";
import { Blog } from "./pages/Blog";
import { Contact } from "./pages/Contact";
import { Links } from "./pages/Links";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Rota especial de links sem Header e Footer padrão */}
          <Route path="/links" element={<Links />} />

          {/* Rotas padrão com Header e Footer */}
          <Route
            path="*"
            element={
              <>
                <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/sobre" element={<About />} />
                    <Route path="/servicos" element={<Services />} />
                    <Route path="/galeria" element={<Gallery />} />
                    <Route path="/depoimentos" element={<Testimonials />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/contato" element={<Contact />} />
                  </Routes>
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
